import { NgModule } from '@angular/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatChipsModule } from '@angular/material/chips';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [],
  imports: [
    MatGridListModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatChipsModule
  ],
  exports: [
    MatGridListModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatChipsModule
  ]
})
export class MaterialModule { }
